<template>
    <div @mouseover="keepOpen" v-on-clickaway="showTitle" id="favorites" ref="favorites">
        <div class="favorites-container wrapper">
            <a v-if="this.windowWidth > 400" href="/favorites" ref="btn" class="btn-orange view-my-favorites">{{ trans('talents.profile.view_my_favorites') }}</a>
            <a v-if="this.windowWidth < 401" href="/favorites" ref="btn" class="btn-orange view-my-favorites ">{{ trans('talents.profile.view_my_favorites_small') }}</a>
            <h2 @click="showToggle()">{{ trans('talents.favorites.your_selection') }}
                <span class="favorites-title">({{projectFavorites.length}})</span>
                <div class="favorites-open-close" :class="open ? 'open' : 'closed'"></div>
            </h2>
            <div v-for="(model, index) in projectFavorites" :key="model.id" class="thumb">
                <img v-lazy="firstFoto(model)" :alt="model.Voornaam +' '+model.Achternaam_letter">
            </div>
        </div>
    </div>
</template>
<script type='text/babel'>
    import {mapState} from 'vuex'
    import {TweenMax} from "gsap/all"
    import {mixin as clickaway} from 'vue-clickaway';

    export default {
        mixins: [clickaway],
        data: function () {
            return {
                open: false,
                timer: false
            }
        },
        mounted() {
            window.addEventListener('resize', ev => {
               this.timer = setTimeout(function () {
                    this.showTitle()
                }.bind(this), 500);
            })
        },
        computed: {
            ...mapState(['models']),
            ...mapState(['favorites']),
            ...mapState(['project']),
            ...mapState(['forceReloadFavorites']),
            projectFavorites() {
                return this.favorites[this.project] ? this.favorites[this.project]: false
            }
        },
        watch: {
            forceReloadFavorites() {
                setTimeout(function(){
                    if (this.projectFavorites.length > 0 && this.projectFavorites.length < 5) {
                        this.showAll()
                    } else {
                        this.showTitle()
                    }
                }.bind(this),500)
            }
        },
        methods: {
            firstFoto(model) {
                if(model.fotos[0]) {
                    let id = model.fotos[0].ID_Foto
                    return '/models/' + id + '.jpg'
                }
                return ''
            },
            showToggle() {
                if (this.open) {
                    this.showTitle()
                }
                else {
                    this.showAll()
                }
            },
            showAll() {
                this.open = true;
                let top = this.windowHeight - 210;
                TweenMax.to(this.$refs.favorites, 0.6, {top: top, opacity: 1})
                TweenMax.to(this.$refs.btn, 0.6, {marginTop: 0})
                if (this.windowWidth > 400) {
                    this.slowlyHide()
                }
            },
            keepOpen() {
                clearTimeout(this.timer)
            },
            slowlyHide() {
                this.timer = setTimeout(function () {
                    this.showTitle()
                }.bind(this), 3500)
            },
            showTitle() {
                this.open = false;
                let top = window.innerHeight - 63;
                TweenMax.to(this.$refs.favorites, 0.6, {top: top, opacity: 1})
                TweenMax.to(this.$refs.btn, 0.6, {marginTop: 0})
            },
        },
    };
</script>
